module.exports = __webpack_public_path__ + "img/IMG_8673_L_BlackMatted.9273beaa.jpg";